import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Image from '@tiptap/extension-image';
import Placeholder from '@tiptap/extension-placeholder';
import Highlight from '@tiptap/extension-highlight';
import TextAlign from '@tiptap/extension-text-align';
import Toolbar from './Toolbar';

interface Props {
  /** 初始內容：Tiptap JSON 字串，或（遷移文章）HTML 字串。 */
  initialJson: string | null;
  initialHtml: string | null;
  onChange?: (json: string) => void;
  /** 唯讀預覽（無工具列）。 */
  readOnly?: boolean;
}

function initialContent(json: string | null, html: string | null): object | string {
  if (json) {
    try {
      return JSON.parse(json) as object;
    } catch {
      /* fall through */
    }
  }
  return html ?? '';
}

/** 所見即所得編輯器；遷移文章無 JSON 時直接吃 body_html_legacy。 */
export default function Tiptap({ initialJson, initialHtml, onChange, readOnly = false }: Props) {
  const editor = useEditor({
    editable: !readOnly,
    extensions: [
      StarterKit.configure({ link: { openOnClick: false } }),
      Image,
      Highlight,
      TextAlign.configure({ types: ['heading', 'paragraph'] }),
      Placeholder.configure({ placeholder: '開始撰寫內容…' }),
    ],
    content: initialContent(initialJson, initialHtml),
    onUpdate: ({ editor: e }) => onChange?.(JSON.stringify(e.getJSON())),
  });

  if (!editor) return null;

  return (
    <div className="rounded-lg border border-gray-200 bg-white">
      {!readOnly && <Toolbar editor={editor} />}
      <EditorContent
        editor={editor}
        className="tiptap-content min-h-[420px] px-5 py-4 [&_.ProseMirror]:min-h-[400px] [&_.ProseMirror]:outline-none"
      />
    </div>
  );
}
